import { gql } from "@apollo/client";

export const GET_CITIES = gql`
  query ($cityName: String, $lang: String, $ids: [Int]) {
    cities(cityName: $cityName, lang: $lang, ids: $ids) {
      CityId
      CityName
      BusStops {
        BusStopId
        BusStopName
        CountryName
      }
    }
  }
`;
